import { isRtl } from '@common/html/util/dom';
import { EditorEvent } from '@portal-core/project-files/events/editor-event.event';
import { NodeViewBase } from '@portal-core/text-editor/node-views/node-view.base';
import { GetPosForNodeView } from '@portal-core/text-editor/node-views/types/nodeview-get-pos.type';
import { BidiBridge } from '@portal-core/util/bidi-bridge';
import { Node } from 'prosemirror-model';
import { Decoration, EditorView, NodeView } from 'prosemirror-view';

export class HtmlNodeView extends NodeViewBase implements NodeView {
  private resizeObserver: ResizeObserver;

  constructor(
    node: Node,
    editorView: EditorView,
    getPos: GetPosForNodeView,
    decorations: Decoration[],
    nodeViewBridge: BidiBridge<EditorEvent, EditorEvent>,
    editorTagName: string
  ) {
    super(node, editorView, getPos, decorations, nodeViewBridge, editorTagName);

    this.contentDOM = this.dom;

    // Listen to the html DOM's size changing to let the editor know
    this.resizeObserver = new ResizeObserver(() => {
      this.emitEvent('node-view-size-changed', { nodeName: node.type.name });
    });

    this.resizeObserver.observe(this.dom);

    this.syncNode(node);
  }

  destroy() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    super.destroy();
  }

  syncNode(node: Node) {
    if (isRtl(node.attrs['xml:lang'])) {
      this.dom.setAttribute('dir', 'rtl');
    } else {
      this.dom.removeAttribute('dir');
    }
  }
}
